import React, {useEffect, useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {getSlateLink} from '../../helpers/linkHelper';
import {api} from '../../config/constants';

var SlateNewData = function(props) {
  var uuid = props.uuid;
  var t = props.t;

  var loadingState = useState(true);
  var isLoading = loadingState[0];
  var setIsLoading = loadingState[1];

  var copyState = useState(null);
  var copiedField = copyState[0];
  var setCopiedField = copyState[1];

  useEffect(function() {
    setIsLoading(true);
  }, [uuid, setIsLoading]);

  function handleImageLoad() {
    setIsLoading(false);
  }

  function handleCopy(field) {
    setCopiedField(field);
    setTimeout(function() {
      setCopiedField(null);
    }, 1500);
  }

  var link = getSlateLink(uuid);
  var qrSrc = api.GET_SLATE + '/' + uuid + '/qr?size=500';

  return (
    <div className="slate-qr-result">
      <div className="slate-qr-result-code">
        <div className="slate-generator-qr">
          <img
            key={uuid}
            src={qrSrc}
            style={{
              width: 180,
              height: 180,
              opacity: isLoading ? 0 : 1,
              transition: 'opacity 300ms ease',
            }}
            alt="QR Code"
            onLoad={handleImageLoad}
          />
        </div>
      </div>
      <div className="slate-qr-result-details">
        <div className="slate-qr-field">
          <div className="slate-qr-field-label">
            {t('slateGenerator:slateUUID')}
          </div>
          <div className="slate-qr-field-value-row">
            <div className="slate-qr-field-value">{uuid}</div>
            <CopyToClipboard text={uuid} onCopy={function() { handleCopy('uuid'); }}>
              <button type="button" className={'slate-qr-copy-btn' + (copiedField === 'uuid' ? ' slate-qr-copy-btn--copied' : '')} title="Copy UUID">
                <span className="material-symbols-outlined">
                  {copiedField === 'uuid' ? 'check' : 'content_copy'}
                </span>
              </button>
            </CopyToClipboard>
          </div>
        </div>
        <div className="slate-qr-field">
          <div className="slate-qr-field-label">
            {t('slateGenerator:url')}
          </div>
          <div className="slate-qr-field-value-row">
            <div className="slate-qr-field-value">{link}</div>
            <CopyToClipboard text={link} onCopy={function() { handleCopy('url'); }}>
              <button type="button" className={'slate-qr-copy-btn' + (copiedField === 'url' ? ' slate-qr-copy-btn--copied' : '')} title="Copy URL">
                <span className="material-symbols-outlined">
                  {copiedField === 'url' ? 'check' : 'content_copy'}
                </span>
              </button>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlateNewData;
